export default function(x) {
  return x;
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-format/src/identity.js
// module id = 1398
// module chunks = 0